const error = (input, value) => {
	input.classList.add('is-error')

	input.insertAdjacentHTML('afterend', `<span class="message"><svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.5 0C3.80544 0 0 3.80544 0 8.5C0 13.1946 3.80544 17 8.5 17C13.1946 17 17 13.1946 17 8.5C17 3.80544 13.1946 0 8.5 0ZM8.52571 4.02966C8.89756 4.02966 9.18726 4.32716 9.18726 4.74267C9.18726 5.09946 8.8976 5.43327 8.51118 5.43327C8.13986 5.43327 7.82054 5.09942 7.82054 4.74267C7.82058 4.32716 8.13986 4.02966 8.52571 4.02966ZM10.1156 13.0313H7.07794V12.6303C7.99111 12.5632 8.1024 12.4671 8.1024 11.531V8.61966C8.1024 7.76574 8.07277 7.70591 7.17412 7.58736V7.22331C7.89493 7.08966 8.51118 6.91908 9.09054 6.64395V11.5309C9.09054 12.467 9.1873 12.5632 10.1156 12.6303V13.0313Z" fill="#FF0000"/></svg>${value}</span>`);
}

function num(a) {
	return !a.some(function(b) {
		return b !== a[0]
	})
}

const repeat = (value) => {
	let arr = [...value];
	const vl = arr[1];
	arr.splice(0, 2);
	return num(arr)
}

const validation = (e) => {
	const form = e.target.closest('form')
	const input = form.querySelector('input.mask-phone')
	const inputValue = input.value
	const message = form.querySelector('.message')

	if (message != null) message.remove()

	if (inputValue.length === 0) {
		error(input, 'Обязательно для заполнения')
	} else {
		const str = inputValue.replace(/[^0-9]/g, '');

		if (str.length < 11) {
			error(input, 'Некорректный телефон')
		} else {
			if (repeat(str)) {
				error(input, 'Некорректный телефон')
			} else {
				window.location.href = 'thanks.html';
			}
		}
	}
}

function init() {
	const buttons = document.querySelectorAll('form button')
	const inputs = document.querySelectorAll('input.mask-phone')

	buttons.forEach((button) => {
		button.addEventListener('click', validation)
	})

	inputs.forEach((input) => {
		input.addEventListener('click', (e)=> {
			e.target.classList.remove('is-error')
			if (e.target.nextElementSibling != null) {
				e.target.nextElementSibling.remove()
			}
		})
	})
}

export default {
	init,
};
